import { ContractsFilter, ICompanyContractsFilter } from './ContractsFilter';
import { ContractsTable } from './ContractsTable';
import { CreateButton, useTable } from '@refinedev/antd';
import { CrudFilters, HttpError } from '@refinedev/core';
import { ICompany } from 'interfaces/companies';
import { IContract } from 'interfaces/contracts';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

interface TabCompanyContractsProps {
  company: ICompany;
}

export const TabCompanyContracts = ({ company }: TabCompanyContractsProps) => {
  const { id } = useParams();
  const hasSubmittedInitialFilters = useRef(false);

  const { tableProps, searchFormProps } = useTable<
    IContract,
    HttpError,
    ICompanyContractsFilter
  >({
    resource: `companies/${id}/contracts`,

    onSearch: params => {
      const filters: CrudFilters = [];
      const { by_course_type, by_code, by_course_id } = params;

      filters.push(
        {
          field: 'filter[by_course_type]',
          operator: 'eq',
          value: by_course_type
        },
        {
          field: 'filter[company_id]',
          operator: 'eq',
          value: id
        },
        {
          field: 'filter[by_code]',
          operator: 'eq',
          value: by_code
        },
        {
          field: 'filter[by_course_id]',
          operator: 'eq',
          value: by_course_id
        }
      );

      return filters;
    }
  });

  useEffect(() => {
    if (hasSubmittedInitialFilters.current) return;
    if (!searchFormProps.form) return;

    hasSubmittedInitialFilters.current = true;
    searchFormProps.form.submit();
  }, [searchFormProps.form]);

  return (
    <div>
      <ContractsFilter searchFormProps={searchFormProps} />

      <div className="flex justify-end mb-4">
        <CreateButton
          resource="contracts"
          meta={{ companyId: company.id }}
          className="ml-auto"
        >
          Novo contrato
        </CreateButton>
      </div>

      <ContractsTable tableProps={tableProps} />
    </div>
  );
};
